import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, defineAsyncComponent } from 'vue'
import AppLayout from './layouts/AppLayout.vue'
import AppLayoutStagingBar from './layouts/AppLayoutStagingBar.vue'
import { ENV } from '@/common/config'
import { getStateFeatureFlags } from './store/getters'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isStaging = ENV === 'dev'

const AsyncToastProvider = defineAsyncComponent(() =>
  import('@sennder/shell-utilities').then((m) => m.ToastProvider)
)

const AsyncToastNotifications = defineAsyncComponent(
  () => import('./notifications/ToastNotificationsVue.vue')
)

const canAccessNewNotificationInbox = computed(() => {
  return getStateFeatureFlags()['ENABLE_NEW-NOTIFICATION-INBOX']
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppLayout),
    (canAccessNewNotificationInbox.value)
      ? (_openBlock(), _createBlock(_unref(AsyncToastProvider), {
          key: 0,
          "max-toasts": 10,
          right: 2,
          top: 2
        }))
      : (_openBlock(), _createBlock(_unref(AsyncToastNotifications), { key: 1 })),
    isStaging
      ? (_openBlock(), _createBlock(AppLayoutStagingBar, { key: 2 }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})